import i18next from "i18next";
import {
  EmptyStateContainer,
  EmptyStateMessage,
  EmptyStateTitle,
  LoadingContainer,
  LoadingEmoji,
  PartialStateContainer,
  PartialStateIcon,
  PartialStateMessage,
  ResultContainer,
  ResultImg,
  ResultMessage,
  ResultStatus,
  ResultStatusBlock,
} from "./style";

export const RenderResultSection = ({ loading, result, citizenship, destination, getResultType }) => {
  const { t } = i18next;
  const resultType = getResultType();

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingEmoji>🔍</LoadingEmoji>
        {t("get_visa_loading_message")}
      </LoadingContainer>
    );
  }

  if (citizenship && destination && resultType === "no-data") {
    return (
      <ResultContainer $type={resultType}>
        <ResultStatusBlock>
          <ResultStatus $type={resultType}>{t("no_data")}</ResultStatus>
          <ResultMessage>{t("check_console_website")}</ResultMessage>
        </ResultStatusBlock>
      </ResultContainer>
    );
  }

  if (result && citizenship && destination) {
    return (
      <ResultContainer $type={resultType}>
        {resultType === "visa_required" || resultType === "e_visa" ? (
          <ResultImg src="/images/visa-statuses/visa_required.png" alt="visa required" />
        ) : resultType && resultType.includes("visa_free") ? (
          <ResultImg src="/images/visa-statuses/visa_free.png" alt="visa free" />
        ) : resultType === "visa_on_arrival" ? (
          <ResultImg src="/images/visa-statuses/visa_on_arrival.png" alt="visa on arrival" />
        ) : (
          ""
        )}
        <ResultStatusBlock>
          <ResultStatus $type={resultType}>
            {citizenship === destination ? t("in_house") : t(result.message?.title)}
          </ResultStatus>

          <ResultMessage>{citizenship === destination ? "" : t(result.message?.desc)}</ResultMessage>
        </ResultStatusBlock>
      </ResultContainer>
    );
  }

  if ((citizenship && !destination) || (!citizenship && destination)) {
    return (
      <PartialStateContainer>
        <PartialStateIcon>⚠️</PartialStateIcon>
        <PartialStateMessage>{!citizenship ? t("select_citizenship") : t("select_destination")}</PartialStateMessage>
      </PartialStateContainer>
    );
  }

  return (
    <EmptyStateContainer>
      <EmptyStateTitle>{t("get_visa_result_title")}</EmptyStateTitle>
      <EmptyStateMessage>{t("get_visa_result_desc")}</EmptyStateMessage>
    </EmptyStateContainer>
  );
};
